import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import businessOnboardingApi from '../../api/businessOnboarding';

export default function LocationLetterReturn() {
  const navigate = useNavigate();
  const { businessId } = useParams();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  const formatFinalizeError = (e) => {
    if (!e?.response) {
      return 'Could not reach the server to finalize payment (network/CORS/proxy issue). Please retry in a few seconds.';
    }

    const apiCode = e?.response?.data?.code;
    if (apiCode === 'location_letter_dispatch_failed') {
      return e?.response?.data?.message || 'Location letter provider rejected the request. Please verify address details and try again.';
    }

    return e?.response?.data?.message || e?.message || 'Failed to finalize location verification payment';
  };

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      try {
        if (!businessId) return;
        const sessionId = searchParams.get('session_id');
        if (!sessionId) {
          throw new Error('Missing checkout session id');
        }

        await businessOnboardingApi.confirmLocationLetterPayment(businessId, sessionId);

        navigate(`/business/${businessId}/onboarding/location-letter-verify`, { replace: true });
      } catch (e) {
        if (!mounted) return;
        setError(formatFinalizeError(e));
        setTimeout(() => {
          navigate(`/business/onboarding/${businessId}`, { replace: true });
        }, 1300);
      }
    };

    run();
    return () => {
      mounted = false;
    };
  }, [businessId, navigate, searchParams]);

  return (
    <div className="tailwind">
      <div className="flex min-h-[60dvh] w-full flex-col items-center justify-center gap-3 bg-gray-50 px-4">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-indigo-600" />
        <div className="text-sm text-gray-700">Finalizing location verification payment…</div>
        {error && <div className="text-xs text-red-700">{error}</div>}
      </div>
    </div>
  );
}
